import {all} from 'redux-saga/effects'
import {watchDealers} from './dealers'
import {watchFetchMainServices, watchSaveMainServices} from './mainServices'
import {watchFetchTires, watchSaveTires} from './tires'
import {watchFetchUsers} from './users'
import {watchLogin} from './authentication'
import {watchFetchInterventions, watchFetchInterventionsOverview} from "./interventions";
import {watchFetchDistinctAdvisors} from "./advisors";
import {watchFetchServices, watchFetchServicesRepair, watchSaveServices} from "./services";
import {watchFetchMobility, watchSaveMobility} from "./mobility";
import {watchFetchPictures} from "./pictures";
import {watchFetchPlanningManagement, watchSavePlanningManagement} from "./planningManagement";
import {watchNotifications} from "./notifications";
import {watchFetchOpeningHours, watchSaveOpeningHours} from "./openingHours";
import {watchFetchMonthlyPlanning, watchSaveMonthlyPlanning} from "./monthlyPlanning";
import {watchFetchDealerInformation} from "./dealer";
import {watchFetchRentalPlanning, watchSaveRentalPlanning} from "./rentalPlanning";
import {watchFetchRentalVehicles} from "./rentals";
import {watchIntervention} from "./intervention";
import {watchJourneyComment} from "./journeyComment";
import {watchIdentity} from "./journeyIdentityDocument";
import {watchFetchInterventionComment, watchSaveInterventionComment} from "./interventionComment";
import {watchFetchAvailabilities} from "./availabilities";
import {watchRentalPark} from "./rentalPark";
import {watchDeleteJourneyDocuments, watchFetchJourneyDocuments, watchSaveJourneyDocuments} from "./journeyDocument";
import {watchConversation} from "./conversation";
import {watchDeleteDealerSafe, watchFetchDealerSafes, watchSaveDealerSave, watchUpdateDealerSave} from "./dealerSafes";
import {watchFetchJourneySignature} from "./journeySignature";
import {watchAssignRentalVehicle, watchDeleteRentalVehicle, watchFetchRentalContract, watchIvsLookup, watchSaveRentalVehicle, watchUnassignRentalVehicle, watchUpdateRentalVehicle,} from "./rental";
import {watchDeleteJourneyTireOffers, watchFetchJourneyTireOffers, watchSaveJourneyTireOffers} from "./journeyTireOffers";
import {watchSendCustomerNotifications} from "./customerNotifications";
import {watchDeliverRentalVehicle, watchFetchRentalDeliveryPlanning, watchFetchRentalReporting, watchReturnRentalVehicle} from "./rentalReporting";
import {watchFetchDealerCodes, watchUpdateDealerCodes} from "./dealerCodes";
import {watchFetchInterventionSafesPlanning, watchFetchSafesPlanning} from "./safesPlanning";
import {watchFetchVehicleContracts} from "./vehicleContracts";
import {watchAssignJourneySafe, watchUnassignJourneySafe} from "./safe";
import {watchUpdateJourneyMobility, watchUpdateJourneyReception, watchUpdateJourneyServices} from "./journeyProperties";
import {watchUpdateJourneyVehicle} from "./journeyVehicle";
import {watchFetchWheelsExchangeConfig} from "./wheelsExchangeConfig";
import {watchFetchWheelsExchangePlanning} from './wheelsExchangePlanning';
import {watchUploadFile} from "./upload";
import {watchFetchFrontendConfig} from "./config";
import {watchFetchDealerConfigurationCheck} from "./dealerConfigurationCheck";
import {watchFetchCustomerJourneyInformation} from "./customerJourney";
import {watchFetchCommunicationBackground, watchFetchCommunicationBanners, watchFetchCommunicationMessages, watchUpdateCommunicationBackground, watchUpdateCommunicationBanners, watchUpdateCommunicationMessages} from "./communication";
import {watchSavePublicContext} from './publicContext'
import {watchSteps} from './stepper'
import {watchFetchFleetbackInterventions} from "./fleetback";
import {watchPolicyDocument} from "./consent";
import {watchCallCenterVinLookup, watchFetchCustomer, watchFetchVehicleProperties} from "./callCenter";
import {watchFetchLeasingCompanies} from "./leasingCompanies";

export default function* rootSaga() {
  yield all([
    watchCallCenterVinLookup(),
    watchFetchLeasingCompanies(),
    watchFetchVehicleProperties(),
    watchFetchCustomer(),
    watchDealers(),
    watchFetchMobility(),
    watchSaveMobility(),
    watchFetchMainServices(),
    watchSaveMainServices(),
    watchFetchTires(),
    watchSaveTires(),
    watchFetchUsers(),
    watchFetchInterventions(),
    watchFetchInterventionsOverview(),
    watchFetchDistinctAdvisors(),
    watchFetchServices(),
    watchFetchServicesRepair(),
    watchSaveServices(),
    watchFetchPictures(),
    watchFetchPlanningManagement(),
    watchSavePlanningManagement(),
    watchFetchOpeningHours(),
    watchSaveOpeningHours(),
    watchFetchMonthlyPlanning(),
    watchSaveMonthlyPlanning(),
    watchFetchDealerInformation(),
    watchFetchRentalPlanning(),
    watchSaveRentalPlanning(),
    watchLogin(),
    watchNotifications(),
    watchIntervention(),
    watchUpdateJourneyServices(),
    watchUpdateJourneyMobility(),
    watchUpdateJourneyReception(),
    watchJourneyComment(),
    watchUpdateJourneyVehicle(),
    watchFetchInterventionComment(),
    watchSaveInterventionComment(),
    watchFetchJourneySignature(),
    watchIdentity(),
    watchFetchJourneyDocuments(),
    watchSaveJourneyDocuments(),
    watchDeleteJourneyDocuments(),
    watchFetchJourneyTireOffers(),
    watchSaveJourneyTireOffers(),
    watchDeleteJourneyTireOffers(),
    watchFetchAvailabilities(),
    watchFetchRentalVehicles(),
    watchSaveRentalVehicle(),
    watchUpdateRentalVehicle(),
    watchDeleteRentalVehicle(),
    watchAssignRentalVehicle(),
    watchFetchRentalContract(),
    watchUnassignRentalVehicle(),
    watchRentalPark(),
    watchSendCustomerNotifications(),
    watchConversation(),
    watchFetchVehicleContracts(),
    watchFetchDealerSafes(),
    watchSaveDealerSave(),
    watchUpdateDealerSave(),
    watchDeleteDealerSafe(),
    watchAssignJourneySafe(),
    watchUnassignJourneySafe(),
    watchFetchRentalDeliveryPlanning(),
    watchFetchRentalReporting(),
    watchDeliverRentalVehicle(),
    watchReturnRentalVehicle(),
    watchFetchDealerCodes(),
    watchUpdateDealerCodes(),
    watchIvsLookup(),
    watchFetchSafesPlanning(),
    watchFetchInterventionSafesPlanning(),
    watchFetchWheelsExchangeConfig(),
    watchFetchWheelsExchangePlanning(),
    watchUploadFile(),
    watchFetchFrontendConfig(),
    watchFetchDealerConfigurationCheck(),
    watchFetchCustomerJourneyInformation(),
    watchFetchCommunicationMessages(),
    watchFetchCommunicationBackground(),
    watchFetchCommunicationBanners(),
    watchUpdateCommunicationMessages(),
    watchUpdateCommunicationBackground(),
    watchUpdateCommunicationBanners(),
    watchSavePublicContext(),
    watchSteps(),
    watchFetchFleetbackInterventions(),
    watchPolicyDocument()
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js